import { CoreStoreType, GameCommunicationMessageType, gameStateActions, IGameCommunicationProcessor } from '@pp/core';

import { MWGameStatus } from '../../../store/slices/mwState/types';
import { MWTimings } from '../../../config/MWTimings';
import { MWSpecificEvents } from '../../../config/events';

import GameCustomEventService from '../../../utilities/GameCustomEventService';

export class GameCommunicationStartDealingProcessor implements IGameCommunicationProcessor {
  messageName = 'startDealing';

  process(message: GameCommunicationMessageType, store: CoreStoreType): void {
    if (store.getState().bets.betStack.length > 0) {
      const dealingTimer = setTimeout(() => {
        store.dispatch(gameStateActions.setCurrentGameStatus(MWGameStatus.MEGA_MULTIPLIER));
      }, MWTimings.MegaMultiplierVisibilityOnStartDealing);

      GameCustomEventService.addGameEventListner(MWSpecificEvents.CLEAR_TIMERS, this.messageName, (e) => {
        clearTimeout(dealingTimer);
        GameCustomEventService.removeGameEventListners(MWSpecificEvents.CLEAR_TIMERS, this.messageName);
      });
    } else {
      store.dispatch(gameStateActions.setCurrentGameStatus(MWGameStatus.WaitForNextGame));
    }
  }
}
